/**
 * FairPlay UUID.
 *
 * @group DRM
 *
 * @beta
 */
export const FAIRPLAY_UUID = '29701fe4-3cc7-4a34-8c5b-ae90c7439a47';
//# sourceMappingURL=FAIRPLAY_UUID.js.map